<template>
  <div>
    <TeCareerAboutIndexCover />
    <TeCareerAboutIndexAbout />
    <TeCareerAboutIndexMerit />
    <TeCareerAboutIndexHowto />
    <TeCareerAboutIndexExample />
    <TeCareerAboutIndexResult />
    <TeCareerAboutIndexFlow />
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { scriptTagsByConfig } from '~/utility/scriptTags'
import TeCareerAboutIndexCover from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexCover/TeCareerAboutIndexCover.vue';
import TeCareerAboutIndexAbout from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexAbout/TeCareerAboutIndexAbout.vue';
import TeCareerAboutIndexMerit from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexMerit/TeCareerAboutIndexMerit.vue';
import TeCareerAboutIndexHowto from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexHowto/TeCareerAboutIndexHowto.vue';
import TeCareerAboutIndexExample from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexExample/TeCareerAboutIndexExample.vue';
import TeCareerAboutIndexResult from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexResult/TeCareerAboutIndexResult.vue';
import TeCareerAboutIndexFlow from '@/components/Te/TeCareerAbout/Index/TeCareerAboutIndexFlow/TeCareerAboutIndexFlow.vue';

const options = {
  oldHead() {
    const env = process.env.NODE_ENV || 'development'
    const scriptTags = scriptTagsByConfig({
      env: env as 'production' | 'development',
      useCase: 'index',
    })
    return {
      title: '受講生限定の転職支援サービス「テックアカデミーキャリア」 |テックアカデミー',
      meta: [
        ...metaTags({
            keywords:
              '転職, 求人, 転職サイト, 技術者, エンジニア 転職, スカウト, 職務経歴書, it業界',
            description:
              'テックアカデミー受講生限定の転職サービス「テックアカデミーキャリア」は、学習で身につけたスキルや登録したプロフィールをもとに企業やコンサルタントからスカウトが届きます。無料で利用できる転職支援サービスです。',
            twitterTitle:
              '受講生限定の転職支援サービス「テックアカデミーキャリア」',
            twitterDescription:
              'テックアカデミー受講生限定の転職サービス「テックアカデミーキャリア」は、学習で身につけたスキルや登録したプロフィールをもとに企業やコンサルタントからスカウトが届きます。無料で利用できる転職支援サービスです。',
            twitterImage: '/_nuxt/ogp/og-image-career.jpg',
            ogTitle: '受講生限定の転職支援サービス「テックアカデミーキャリア」',
            ogDescription:
              'テックアカデミー受講生限定の転職サービス「テックアカデミーキャリア」は、学習で身につけたスキルや登録したプロフィールをもとに企業やコンサルタントからスカウトが届きます。無料で利用できる転職支援サービスです。',
            ogUrl: '/career',
            ogImage: '/_nuxt/ogp/og-image-career.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  components: {
    TeCareerAboutIndexCover,
    TeCareerAboutIndexAbout,
    TeCareerAboutIndexMerit,
    TeCareerAboutIndexHowto,
    TeCareerAboutIndexExample,
    TeCareerAboutIndexResult,
    TeCareerAboutIndexFlow,
  },
}

export default defineNuxtComponent(options)
</script>
